module.exports = __webpack_public_path__ + "static/media/regular_paper_straw_black1.67b07f3d.png";